import React ,{ Component } from 'react';
import classNames from 'classnames/bind';
import RequestSent from './request-sent';
import Api from '../../Utils/api';

const CLOUD_URL1 = "https://fast-brook-7822.herokuapp.com/acceptNewLead";
const CLOUD_URL = " https://morning-crag-71390.herokuapp.com/acceptNewLead";

export default class Register extends Component {

    constructor(props){
        super(props);
        this.state = {
            requestSent : false,
            showSpinner : false,
            buttonText  : 'Submit'
        };
        this.submit = this.submit.bind(this);
    }

    submit(e){

        e.preventDefault();

        this.setState({
            showSpinner : true,
            buttonText  : 'Submitting'
        });
        let self = this;

        let data = {
            firstName   : this.refs.firstName.value,
            lastName    : this.refs.lastName.value,
            resName     : this.refs.resName.value,
            resZipCode  : "UNKNOWN",
            phoneNumber : "UNKNOWN",
            email       : this.refs.email.value,
            textMessage : this.refs.textMessage.value
        };

        Api.acceptNewLead(data)
            .then(
                function (responseData, textStatus, jqXHR){
                let value = responseData.data;
                self.setState({
                    requestSent : true,
                    showSpinner : false
                });
                },
                function (responseData, textStatus, errorThrown){
                    self.setState({
                        requestSent : false,
                        showSpinner : false,
                        buttonText  : 'Some error occurred! Try Again !'
                    });
                }
            );

        //$.ajax({
            //type        : 'POST',
            //url         : CLOUD_URL,
            //crossDomain : true,
            //data        : JSON.stringify(data),
            //dataType    : 'json',
            //success  : function (responseData, textStatus, jqXHR){
                //let value = responseData;
                //console.log(value);
                //self.setState({
                    //requestSent : true,
                    //showSpinner : false
                //});
            //},
            //error : function (responseData, textStatus, errorThrown){
                //console.log(JSON.stringify(responseData));
                //self.setState({
                    //requestSent : false,
                    //showSpinner : false,
                    //buttonText  : 'Some error occurred! Try Again !'
                //});
            //}
        //});
    }

    render(){

        let spinnerStyle = classNames('fa fa-spinner fa-pulse',
                                      {'show'   : this.state.showSpinner},
                                      {'hidden' : !this.state.showSpinner}
                                     );

        return(
            <div>
                {!this.state.requestSent?
                (<div className="section contact-us-pg" id="contact-us">
                    <div className="container">

                        <div className="row">
                            <div className="col-md-12">
                                <h1 className="text-center">
                                    Interested in Free Demo?<br/>
                                        Contact Us.
                                </h1>

                            </div>
                        </div>


                        <div className="row">
                          <div className="col-md-offset-3 col-md-6">
                              <form role="form" className="form-horizontal" onSubmit={this.submit}>
                                <fieldset>

                                  <div className="form-group">
                                    <div className="col-sm-6">
                                        <input id="fName" ref="firstName" type="text" placeholder="First Name"  className="form-control input-ovd" required autofocus/>
                                    </div>

                                    <div className="col-sm-6">
                                        <input id="lName" ref="lastName" type="text" placeholder="Last Name"  className="form-control input-ovd" required autofocus/>
                                    </div>
                                  </div>

                                  <div className="form-group">
                                      <div className="col-sm-12">
                                          <input id="resName" ref="resName" type="text" placeholder="Restaurant Name" className="form-control input-ovd" required autofocus/>
                                      </div>
                                  </div>

                                  <div className="form-group">
                                    <div className="col-sm-12">
                                        <input id="email" ref="email" type="email" placeholder="Email" className="form-control input-ovd" required autofocus/>
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <div className="col-sm-12">
                                        <textarea id="textMsg" ref="textMessage" className="form-control input-ovd-txtarea" placeholder="If you would like us to call you, type your phone number and convenient time and we will call you back." rows="3"></textarea>
                                    </div>
                                  </div>

                                  <div className="form-group">
                                      <div className="col-sm-12 text-center" style={{marginTop:70,marginBottom:176}}>
                                          <button type="submit" className="btn-submit-cta" disabled={this.state.showSpinner}>
                                              <i className={spinnerStyle}></i> {this.state.buttonText}
                                          </button>
                                      </div>
                                 </div>

                                </fieldset>
                              </form>
                          </div>
                        </div>
                    </div>
                </div>)
                :null}
                {this.state.requestSent?<RequestSent/>:null}
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/layout/contact-us.js